const element = require("app/util/element");
const className = "keyboard-input-in-focus";

const acceptedSelection = [
	"input[type=text]",
	"input[type=email]",
	"textarea"
];

function isAcceptable(el) {
	const targetElement = element(el);
	let accepted = false;

	for (let i = 0; i < acceptedSelection.length; i++) {
		accepted = targetElement.is(acceptedSelection[i]);

		if (accepted) {
			break;
		}
	}

	return accepted;
}

/////////////////////////////////
// Focus in
/////////////////////////////////

document.addEventListener("focus", e => {
	if (!isAcceptable(e.target)) {
		return;
	}

	const classList = document.body.className.split(" ");

	if (classList.indexOf(className) === -1) {
		classList.push(className);
	}

	document.body.className = classList.join(" ");

}, true);

/////////////////////////////////
// Focus out
/////////////////////////////////

document.addEventListener("blur", () => {
	let classList = document.body.className.split(" ");
	const index = classList.indexOf(className);

	if (index > -1) {
		classList.splice(index, 1);
	}

	document.body.className = classList.join(" ");

}, true);